export default __webpack_public_path__ + "static/media/stignatius.bbafe03b.jpg";